import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './components/globalComponents/login/styles/resetPassword.scss';
import './styles/text.scss';
import './styles/main.css';

import { Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/homePage/homePage';
import { ChatProvider } from './context/chatContext';
import { AuthProvider } from './context/authProviderContext';
import PrivateRoute from './routes/PrivateRoute';
import UserPanel from './components/userComponents/userPanel/UserPanel';
import { NewsProvider } from './context/newsContext';
import { LicensesProvider } from './context/licensesContext';
import { ProjectsProvider } from './context/projectsContext';
import { useEffect, useState } from 'react';
import AuthModal from './components/globalComponents/login/authModal';
import AboutUsPage from './pages/aboutUsPage/aboutUsPage';
import ContactPage from './pages/contactPage/contactPage';
import ProductsPage from './pages/productsPage/productsPage';
import ProductsInfoPage from './pages/productsPage/productsinfoPage/productsinfoPage';
import ServicesInfoPage from './pages/productsPage/servicesInfoPage/servicesInfoPage';
import InvestigaciónDesarrolloInnovación from './pages/I+D+iPage/i+d+ipage';
import FormularioEnviado from './pages/contactPage/formularioEnviado/formularioEnviado';
import ServicePage from './pages/sevicesPage/servicesPage'; 
import EnConstruccion from './pages/enConstruccion/enConstruccion';

const App = () => {
  const location = useLocation();
  const [modalType, setModalType] = useState(null);
  const [preloadedEmail, setPreloadedEmail] = useState('');

  useEffect(() => {
    if (location.state?.openLoginModal) {
      const email = localStorage.getItem('reset_email') || '';
      if (email) {
        setPreloadedEmail(email);
        localStorage.removeItem('reset_email');
      }
      setModalType('login');
    }
  }, [location]);

  return (
    <AuthProvider>
      <ChatProvider>
        <div id="n8n-chat" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/AboutUsPage" element={<AboutUsPage />} />
          <Route path="/Productos" element={<ProductsPage />} />
          <Route path="/Productos/products" element={<ProductsInfoPage />} />
          <Route path="/Productos/services" element={<ServicesInfoPage />} />
          <Route path="/Servicios" element={<ServicePage />} />
          <Route path="/Contacto" element={<ContactPage />} />
          <Route
            path="/I+D+i"
            element={<InvestigaciónDesarrolloInnovación />}
          />
          <Route path="/mensaje-enviado" element={<FormularioEnviado />} />
                    {/* ===== RUTAS NUEVAS DEL MENÚ (provisionales) ===== */}
          <Route path="/servicios" element={<EnConstruccion titulo="Servicios" />} />
          <Route path="/consultoria-neuroinclusiva" element={<EnConstruccion titulo="Consultoría neuroinclusiva" />} />
          <Route path="/creatividad-audiovisual" element={<ServicesInfoPage />} />
          <Route path="/formacion" element={<EnConstruccion titulo="Formación" />} />
          <Route path="/neurocinema-project" element={<EnConstruccion titulo="Neurocinema Project" />} />
          <Route path="/sectores/:sector" element={<EnConstruccion titulo="Sectores" />} />
          <Route path="/proyectos" element={<ProductsInfoPage />} />
          <Route path="/recursos" element={<EnConstruccion titulo="Recursos" />} />
          <Route path="/nosotros" element={<AboutUsPage />} />
          <Route path="/solicitar-propuesta" element={<ContactPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <NewsProvider>
                  <ProjectsProvider>
                    <LicensesProvider>
                      <UserPanel />
                    </LicensesProvider>
                  </ProjectsProvider>
                </NewsProvider>
              </PrivateRoute>
            }
          />
        </Routes>
        {modalType && (
          <AuthModal
            modalType={modalType}
            setModalType={setModalType}
            preloadedEmail={preloadedEmail}
          />
        )}
      </ChatProvider>
    </AuthProvider>
  );
};

export default App;
